class navSubmenu {
  constructor(settings) {
    this.container = settings.container;
    this.expandedDesktop = settings.expandedDesktop;
    this.expandedMobile = settings.expandedMobile;
    this.expanded = false;
    this.mediaQuery = window.matchMedia('(min-width: 61.25em)');
    this.toggleEvent = null;
    this.trigger = settings.trigger;
    this.isSubmenu = [...settings.container.classList].includes('js-nav__submenu-inner');
  }

  bindEvents() {
    this.trigger.addEventListener('click', this.toggleVisibility.bind(this));
    this.mediaQuery.addEventListener('change', this.resetState.bind(this, true));
  }

  openSearchbar() {
    const isMobile = !this.mediaQuery.matches;

    if (this.expanded && isMobile) {
      this.toggleVisibility(this, false);
    }
  }

  resetState(dispatch) {
    this.setExpandedDefault();
    this.setState(dispatch);
    document.body.classList.remove('is-menu');
  }
  setExpandedDefault() {
    this.expanded = this.mediaQuery.matches ? this.expandedDesktop : this.expandedMobile;
  }
  setState(dispatch = true) {
    this.trigger.setAttribute('aria-expanded', this.expanded);
    this.container.hidden = !this.expanded;
    if (dispatch === true) {
      this.trigger.dispatchEvent(this.toggleEvent);
    }
  }
  toggleVisibility() {
    this.expanded = !this.expanded;
    this.container.classList.toggle('is-active');
    this.setState();

    if ((!this.mediaQuery.matches && this.isSubmenu) || this.expanded) {
      // submenu item is expanded or mobile nav is now expanded
      document.body.classList.add('is-menu');
    } else {
      // close mobile menu toggle OR close desktop subnav items
      document.body.classList.remove('is-menu');
    }

    this.setState(false);

    if (this.expanded) {
      document.querySelector('.js-searchbar').classList.remove('is-active');
      document.body.classList.remove('is-search');
    }
  }
  init() {
    this.toggleEvent = new CustomEvent('toggle', {
      detail: this,
    });
    this.setExpandedDefault();
    this.setState();
    this.bindEvents();
  }
}

export default navSubmenu;
